import {initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";
import {getStorage} from "firebase/storage";
import {getFirestore} from "firebase/firestore";

// dev Branch firebase config
export const firebaseConfig = {
  apiKey: "AIzaSyCMMx1I2nWjWRqsXIbNzvSCoykf4UoObiU",
  authDomain: "my-asset-82eba.firebaseapp.com",
  projectId: "my-asset-82eba",
  storageBucket: "my-asset-82eba.appspot.com",
  messagingSenderId: "53567600610",
  appId: "1:53567600610:web:5b8da58f253b8880032bbb",
  measurementId: "G-Z6CLXTD0VK",
};

//Btp
// const firebaseConfig = {
//   apiKey: "AIzaSyCCd36cskO5H5R3Ehr_KNhRCsNYd0SQJUw",
//   authDomain: "asset-management-btp.firebaseapp.com",
//   projectId: "asset-management-btp",
//   storageBucket: "asset-management-btp.firebasestorage.app",
//   messagingSenderId: "321426639692",
//   appId: "1:321426639692:web:82a2cd1e5a8853f8a0dde9",
// };

// Aracdis
// const firebaseConfig = {
//   apiKey: "AIzaSyC_w0IE0MJNZwsnJLaITPgEtayJFpP_eYE",
//   authDomain: "arcadis-89282.firebaseapp.com",
//   projectId: "arcadis-89282",
//   storageBucket: "arcadis-89282.firebasestorage.app",
//   messagingSenderId: "604166867257",
//   appId: "1:604166867257:web:440c462dc55dbe4e7ac0e8",
//   measurementId: "G-0T6TZ9CFTD"
// };

// my personal
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBXPLL49Bih6pK-z5BqBtW_pvAcnh7slpU",
//   authDomain: "eduate2.firebaseapp.com",
//   projectId: "eduate2",
//   storageBucket: "eduate2.appspot.com",
//   messagingSenderId: "735882090232",
//   appId: "1:735882090232:web:01b4872ff4e1757c7e0d0d",
//   measurementId: "G-1FPBB30H9C",
// };
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export {auth, db};
export {storage as default};
